import { render } from "./BrandLogos.vue?vue&type=template&id=47309caa&scoped=true"
import script from "./BrandLogos.vue?vue&type=script&lang=js"
export * from "./BrandLogos.vue?vue&type=script&lang=js"

import "./BrandLogos.vue?vue&type=style&index=0&id=47309caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47309caa"]])

export default __exports__